export const getIneligibleDistricts = (dob, districts, districtOptions, selectedGrade, currentYear) => {
  if (!dob || !Array.isArray(districts)) return [];

  const birthdayCheck = new Date(dob);

  const requiredAge = selectedGrade === "Pre-K" ? 4 : 5;

  birthdayCheck.setFullYear(birthdayCheck.getFullYear() + requiredAge);

  return districts
    .map(d => {
      const district = districtOptions.find(opt => opt.id === d);

      if (!district?.options?.cutoff) return null;

      const cutoffDate = new Date(
        currentYear,
        district.options.cutoff.month - 1,
        district.options.cutoff.day
      );

      return birthdayCheck > cutoffDate ? district : null;
    })
    .filter(Boolean);
};
